"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesforceChangeEventSchema = void 0;
const joi_1 = __importDefault(require("joi"));
exports.SalesforceChangeEventSchema = joi_1.default.object({
    ChangeEventHeader: joi_1.default.object({
        commitNumber: joi_1.default.number().required(),
        commitUser: joi_1.default.string().required(),
        sequenceNumber: joi_1.default.number().required(),
        entityName: joi_1.default.string().required(),
        changeType: joi_1.default.string()
            .allow('CREATE', 'UPDATE', 'DELETE', 'UNDELETE', 'GAP_CREATE', 'GAP_UPDATE', 'GAP_DELETE', 'GAP_UNDELETE')
            .required(),
        changedFields: joi_1.default.array().items(joi_1.default.string()).required(),
        changeOrigin: joi_1.default.string().allow('').required(),
        transactionKey: joi_1.default.string().required(),
        commitTimestamp: joi_1.default.number().optional(),
        recordIds: joi_1.default.array().items(joi_1.default.string()).required()
    }).required(),
    // These are system fields that exist in all objects, but won't be there for GAP events
    LastModifiedDate: joi_1.default.string().optional(),
    LastModifiedById: joi_1.default.string().optional(),
    // RecordTypeId exists in some objects, e.g. Account
    RecordTypeId: joi_1.default.string().optional()
}).meta({ className: 'SalesforceChangeEvent' });
//# sourceMappingURL=SalesforceChangeEvent.js.map